<template>
  <div class="boost-content">
    <b-card no-body class="overflow-hidden card-style" style="max-width: 631px">
      <b-row no-gutters>
        <b-col md="5">
          <b-card-img
            src="https://picsum.photos/400/400/?image=20"
            alt="Image"
            class="rounded-0 img-content"
          ></b-card-img>
        </b-col>
        <b-col md="5">
          <b-card-body>
            <b-card-text>
              <p class="title-card">Experience 1 Booster</p>
              <p class="text-card">
                <span style="font-weight: bolder">Experience: </span>Experience
                Name
              </p>
              <p class="text-card">
                <span style="font-weight: bolder">Creation Date: </span
                >24/11/2020
              </p>
              <p class="text-card">
                <span style="font-weight: bolder">Status: </span>Active
              </p>
              <p class="text-card">
                <span style="font-weight: bolder">Exposure: </span>Duration
              </p>
              <b-progress :value="value" class="w-85 mb-2"></b-progress>
              <p class="text-card">
                <span style="font-weight: bolder">Budget: </span>USD 14.16
              </p>
              <p class="text-card">
                <span style="font-weight: bolder">Exposure: </span>
              </p>
              Last update: 3m ago
            </b-card-text>
          </b-card-body>
        </b-col>
        <b-col md="2" class="btn-container">
          <button class="button"><img :src="icon" alt=""></button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import icon from "../../assets/images/ew-icon_published.png";
export default {
  data() {
    return {
      value: 75,
      icon
    };
  },
};
</script>

<style lang="scss" scoped>
$main-color: #93014a;

.card-style {
  height: 222px;
  line-height: 0.5;

  .img-content {
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
    height: 100%;
  }
  .title-card {
    font-size: 14px;
    font-weight: bolder;
  }
  .text-card {
    font-size: 14px;
  }
  .btn-container {
    text-align: end;
    .button {
      background-color: #8bc53f;
      height: 100%;
      width: 45px;
    }
  }
}
</style>